import { AppBar, Box, Hidden, IconButton, Stack, Toolbar } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router';
import { MDMLogoHorizontalWithTitle, CompanyLogoHorizontalWithTitle } from 'src/components/logo';
import ThemeToggleButton from 'src/components/ThemeToggleButton';
import MenuIcon from '../../../icons/Menu';
import AccountPopover from './AccountPopover';
import SystemInfoPopover from "./SystemInfoPopover";
import useSettings from "../../../hooks/useSettings";

const DashboardNavbarRoot = styled(AppBar)(({ theme }) => ({
  ...(theme.palette.mode === 'light' && {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    color: theme.palette.primary.contrastText
  }),
  ...(theme.palette.mode === 'dark' && {
    backgroundColor: theme.palette.primary.main,
    borderBottom: `1px solid ${theme.palette.divider}`,
    boxShadow: 'none'
  }),
  zIndex: theme.zIndex.drawer + 100
}));

const DashboardNavbar = (props) => {
  const { onSidebarMobileOpen, ...other } = props;
  const theme = useTheme();
  const { settings } = useSettings();

  return (
    <DashboardNavbarRoot {...other}>
      <Toolbar sx={{ minHeight: 64 }}>
        <Hidden lgUp>
          <IconButton
            color="inherit"
            onClick={onSidebarMobileOpen}
          >
            <MenuIcon fontSize="small" />
          </IconButton>
        </Hidden>
        <Hidden lgDown>
          <RouterLink to="/" style={{'textDecoration':'none'}}>
            <Box marginRight={2}>
              {settings.companyName !== "TOKEN MDM" ? (
                  <CompanyLogoHorizontalWithTitle
                      color={"#ffffff"}
                      companyName={settings.companyName}
                      logoUrl={settings.logo}
                      sx={{
                        mt: 1,
                        height: 50,
                        width: 240
                      }}
                  />
              ) : (
                  <MDMLogoHorizontalWithTitle
                      color={theme.palette.primary.contrastText}
                      sx={{
                        mt: 1,
                        height: 50,
                        width: 240
                      }}
                  />)}
            </Box>
          </RouterLink>
        </Hidden>
        <Box sx={{ flexGrow: 1, ml: 2 }} />
        {/* Single Stack so every navbar utility gets the same 8 px gap;
            previously SystemInfoPopover had a 32 px `mr` and the others
            had 8 px `ml`, leaving a visible gap to its left. */}
        <Stack direction="row" spacing={1} alignItems="center">
          <SystemInfoPopover />
          <ThemeToggleButton />
          <AccountPopover />
        </Stack>
      </Toolbar>
    </DashboardNavbarRoot>
  );
};

DashboardNavbar.propTypes = {
  onSidebarMobileOpen: PropTypes.func
};

export default DashboardNavbar;
